import type { ColDef } from 'ag-grid-community';

import { useDailyTaskGridDragColumns, useSyncColumnStateFromUser } from '../../../state/dailyTasks';

export const useColumnsState = (columnDefs: ColDef[]) => {
  useSyncColumnStateFromUser();
  return useDailyTaskGridDragColumns(columnDefs);
};
